import config from '../configuration/config';

type ParametersExceptFirst<F> =
  /* eslint-disable-next-line yola/@typescript-eslint/no-explicit-any */
  F extends (firstArgument: any, ...rest: infer R) => any ? R : never;

function createAccessor<T extends (...args: Parameters<T>) => ReturnType<T>>(
  selector: T
): (...args: ParametersExceptFirst<T>) => ReturnType<T> {
  return (...args: ParametersExceptFirst<T>): ReturnType<T> => {
    const store = config.getStore();

    return selector(...([store.getState(), ...args] as Parameters<T>));
  };
}

export default createAccessor;
